// URLs for binary assets the embed shows. The bundle is a single ES module, so it locates sibling
// files by resolving a build-time-injected filename against its own URL (import.meta.url) rather
// than inlining them: scripts/build-embed.mjs (hashed name, production) and scripts/dev-preview.mjs
// (plain name, preview) both define __BFC_HOST_IMAGE__. Where it isn't defined (typecheck, tests),
// the image is simply absent and every caller degrades to a text-only layout.

declare const __BFC_HOST_IMAGE__: string | undefined;

/** The host's photo (a cutout on a transparent background): the intro screen hero and the
 * avatar inside the loading spinner. Undefined when the build didn't provide one. */
export const hostImageUrl: string | undefined =
  typeof __BFC_HOST_IMAGE__ === "string" ? new URL(__BFC_HOST_IMAGE__, import.meta.url).href : undefined;
